import { render, staticRenderFns } from "./ChatFile.vue?vue&type=template&id=1194a29a"
import script from "./ChatFile.vue?vue&type=script&lang=js"
export * from "./ChatFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports